import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    NgSelectModule,
    NgxCurrencyDirective,

    NgxMaskDirective,
    NgxMaskPipe,
    NgxPaginationModule,
    NgxSkeletonLoaderModule,
    RxReactiveFormsModule,
    TabsModule,
    TooltipModule,
    NgxLoadingModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    NgSelectModule,
    NgxCurrencyDirective,

    NgxMaskDirective,
    NgxMaskPipe,
    NgxPaginationModule,
    NgxSkeletonLoaderModule,
    RxReactiveFormsModule,
    TabsModule,
    TooltipModule,
    NgxLoadingModule,
  ],
})
export class SharedModule {}
